import { validatorCreator } from 'utils/helpers/validators/validatorCreator'
import { parseDigits } from 'utils/formatters/numbers'
import { PHONE_PLACEHOLDER } from 'utils/constants/defaultValues'

export const VALIDATION_ERRORS_ENUM = {
  CANNOT_BE_EMPTY: 'This field is required.',
  PHONE_INVALID: `Phone doesn't match ${PHONE_PLACEHOLDER} format.`,
}

const phoneValidators = [
  {
    name: 'Field cannot be empty',
    isValid: ({ value, isRequired }) => !isRequired || (isRequired && !!value),
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Is entered correct',
    isValid: ({ value }) => (value && parseDigits(value).length === 10) || value === '',
    errorMessage: VALIDATION_ERRORS_ENUM.PHONE_INVALID,
  },
]

export const validatePhone = validatorCreator(phoneValidators)
